// TIND search drawer — slides down from the top, hits the predictive
// search API while typing. Suggest panel shown when input is empty,
// results panel when there's a query, empty state when no matches.

(function () {
  'use strict';

  function init() {
    var drawer = document.querySelector('[data-tind-search-drawer]');
    if (!drawer) return;

    var input = drawer.querySelector('[data-tind-search-input]');
    var form = drawer.querySelector('[data-tind-search-form]');
    var suggest = drawer.querySelector('[data-tind-search-suggest]');
    var results = drawer.querySelector('[data-tind-search-results]');
    var empty = drawer.querySelector('[data-tind-search-empty]');
    var productsList = drawer.querySelector('[data-tind-search-products-list]');
    var pagesList = drawer.querySelector('[data-tind-search-pages-list]');
    var seeAll = drawer.querySelector('[data-tind-search-seeall]');
    var qLabels = drawer.querySelectorAll('[data-tind-search-q]');

    function open() {
      drawer.classList.add('is-open');
      drawer.setAttribute('aria-hidden', 'false');
      document.body.style.overflow = 'hidden';
      setTimeout(function () { if (input) input.focus(); }, 50);
    }
    function close() {
      drawer.classList.remove('is-open');
      drawer.setAttribute('aria-hidden', 'true');
      document.body.style.overflow = '';
      if (input) input.value = '';
      showSuggest();
    }
    function showSuggest() {
      if (suggest) suggest.hidden = false;
      if (results) results.hidden = true;
      if (empty) empty.hidden = true;
    }
    function showResults(payload, q) {
      if (suggest) suggest.hidden = true;
      qLabels.forEach(function (el) { el.textContent = q; });
      var products = (payload && payload.resources && payload.resources.results && payload.resources.results.products) || [];
      var pages = []
        .concat((payload && payload.resources && payload.resources.results && payload.resources.results.articles) || [])
        .concat((payload && payload.resources && payload.resources.results && payload.resources.results.pages) || []);

      if (products.length === 0 && pages.length === 0) {
        if (results) results.hidden = true;
        if (empty) empty.hidden = false;
        return;
      }
      if (empty) empty.hidden = true;
      if (results) results.hidden = false;

      if (productsList) {
        productsList.innerHTML = '';
        products.slice(0, 6).forEach(function (p) {
          var li = document.createElement('li');
          var price = p.price ? formatMoney(p.price) : '';
          li.innerHTML =
            '<a class="tind-search-drawer__product" href="' + p.url + '">' +
            (p.featured_image && p.featured_image.url ? '<img src="' + p.featured_image.url + '" alt="" loading="lazy">' : '<span class="tind-search-drawer__product-thumb"></span>') +
            '<span class="tind-search-drawer__product-meta">' +
            '<span class="tind-search-drawer__product-title">' + p.title + '</span>' +
            (price ? '<span class="tind-search-drawer__product-price">' + price + '</span>' : '') +
            '</span>' +
            '</a>';
          productsList.appendChild(li);
        });
        productsList.parentNode.hidden = products.length === 0;
      }

      if (pagesList) {
        pagesList.innerHTML = '';
        pages.slice(0, 5).forEach(function (item) {
          var li = document.createElement('li');
          li.innerHTML = '<a href="' + item.url + '">' + item.title + '</a>';
          pagesList.appendChild(li);
        });
        pagesList.parentNode.hidden = pages.length === 0;
      }

      if (seeAll) seeAll.href = '/search?q=' + encodeURIComponent(q);
    }

    function formatMoney(input) {
      // input from predictive API can be a string like "kr 295,00" — pass through if so
      if (typeof input === 'string') return input;
      return ((input | 0) / 100).toLocaleString('nb-NO', { minimumFractionDigits: 0, maximumFractionDigits: 2 }) + ' kr';
    }

    var pendingTimer = null;
    function search(q) {
      if (pendingTimer) clearTimeout(pendingTimer);
      pendingTimer = setTimeout(function () {
        var url = '/search/suggest.json?q=' + encodeURIComponent(q) +
          '&resources[type]=product,article,page&resources[limit]=6&resources[options][unavailable_products]=last';
        fetch(url, { headers: { Accept: 'application/json' } })
          .then(function (r) { return r.json(); })
          .then(function (payload) { showResults(payload, q); })
          .catch(function () { /* ignore */ });
      }, 220);
    }

    document.addEventListener('click', function (e) {
      var trigger = e.target.closest && e.target.closest('[data-tind-search-trigger]');
      if (trigger) {
        e.preventDefault();
        open();
      }
    });
    drawer.querySelectorAll('[data-tind-search-close]').forEach(function (el) {
      el.addEventListener('click', close);
    });
    document.addEventListener('keydown', function (e) {
      if (e.key === 'Escape' && drawer.classList.contains('is-open')) close();
    });
    document.addEventListener('search:open', open);
    document.addEventListener('search:close', close);

    if (input) {
      input.addEventListener('input', function () {
        var q = input.value.trim();
        if (q.length === 0) { showSuggest(); return; }
        if (q.length < 2) return;
        search(q);
      });
    }
    if (form) {
      form.addEventListener('submit', function () {
        // Allow native submission to /search?q=...
      });
    }
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
})();
